module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/linescape-vessel-information-anniversary/linescape-vessel-information-anniversary.component.scss
// module id = 833
// module chunks = 0